import { useEffect, useState } from "react";
import serverClock from "../services/serverClock";

const initialSnapshot = (enabled) => {
  const nowMs = enabled ? serverClock.getNowMs() : null;
  return { nowMs, status: nowMs == null ? "idle" : "ready", errorReason: null };
};

// A snapshot belongs to a UI event, not to the lifetime of the shared clock cache.
export const useCapturedServerTime = (enabled = true, refreshKey) => {
  const [capture, setCapture] = useState(() => ({ enabled, refreshKey, value: initialSnapshot(enabled) }));
  let current = capture;
  if (capture.enabled !== enabled || !Object.is(capture.refreshKey, refreshKey)) {
    current = { enabled, refreshKey, value: initialSnapshot(enabled) };
    setCapture(current);
  }
  const ready = current.value.nowMs != null;

  useEffect(() => {
    if (enabled) serverClock.ensureTime();
  }, [enabled, refreshKey]);

  useEffect(() => {
    if (!enabled || ready) return undefined;
    let active = true;
    const update = () => {
      if (!active) return;
      const value = serverClock.getSnapshot();
      setCapture((previous) =>
        previous.value.nowMs != null ? previous : { enabled, refreshKey, value },
      );
    };
    const unsubscribe = serverClock.subscribe(update);
    update();
    return () => {
      active = false;
      unsubscribe();
    };
  }, [enabled, refreshKey, ready]);

  return { ...current.value, isReady: !enabled || ready, retry: serverClock.sync };
};
